import { ObservationCode } from '@quromedical/fhir-common';
import {
  getDataPathologyTestResultFromResponse,
  pathologyReportWithResultsColumns,
} from 'core/diagnostic-report';
import { PatientHeaderSection } from 'core/patient';
import { PaginatedTable } from 'core/table';
import { Section } from 'design-system';
import { useGlobalSearchParams } from 'expo-router';
import type { FetcherOptions } from 'hooks/usePaginatedData';
import { useResponsive } from 'hooks/useResponsive';
import { DiagnosticReportApi } from 'integration';
import type { PathologyStackScreenProps } from 'navigation';
import type React from 'react';
import { ScrollView } from 'react-native';

const api = new DiagnosticReportApi();

type RouteParams = {
  id: string;
  reportId: string;
};

export const DiagnosticResults: React.FC<
  PathologyStackScreenProps<'View'>
> = () => {
  const showHeader = useResponsive({ md: true }, false);
  const isStriped = useResponsive({ md: true }, false);

  const { id, reportId: service } = useGlobalSearchParams<RouteParams>();

  const fetcher = (options: FetcherOptions) =>
    api.getDiagnosticResults({
      subject: id,
      pageToken: options.nextToken,
      basedOn: service,
      code: ObservationCode.pathologyTestResult,
      status: 'final',
    });

  const cacheKey = JSON.stringify({
    subject: id,
  });

  const columns = pathologyReportWithResultsColumns();

  return (
    <ScrollView>
      <PatientHeaderSection id={id} />
      <Section>
        <PaginatedTable
          cacheKey={`DiagnosticResults${cacheKey}`}
          fetcher={fetcher}
          columns={columns}
          showHeader={showHeader}
          isStriped={isStriped}
          getDataFromResponse={getDataPathologyTestResultFromResponse}
        />
      </Section>
    </ScrollView>
  );
};
